import React, { useState } from "react"
import {
  results,
  resultsTop,
  resultsContainer,
  resultItem,
  resultContent,
  resultType,
  resultTypeIcon,
  resultTypeType,
  resultTitle,
  resultResume,
  listResult,
} from "./ResultsTaxo/listResults.module.scss"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import { summaryLength } from "../constants"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import SearchFadeIn from "gatsby-theme-blank/src/components/search-fade-in"
import {
  ResultsContainer,
  ResultContainer,
} from "./ResultsTaxo/results-taxo-styled"
import {
  ResultItems,
  ResultType,
} from "./ResultsTaxo/ResultItem/result-item-styled"
import SearchFilters from "gatsby-theme-blank/src/components/search-filters"

//-----------------------Parent component---------------------------//

const SearchResults = ({ resultats, query }) => {
  const date = new Date()
  resultats = resultats.filter((result) => {
    if (result.field_affichage_planifie && result.field_date_de_publication) {
      if (result.field_date_de_depublication) {
        return (
          new Date(result.field_date_de_publication) <= date &&
          new Date(result.field_date_de_depublication) >= date
        )
      }
      return new Date(result.field_date_de_publication) <= date
    }
    return true
  })

  let tabType = []
  resultats.map((result) => {
    tabType.push(result.type)
    tabType = [...new Set(tabType)]
    return null
  })
  const [choosenType, setChoosenType] = useState(null)
  const toggleType = (typeChoisi, nameType) => {
    if (typeChoisi === nameType) {
      setChoosenType(null)
    } else {
      setChoosenType(nameType)
    }
  }

  if (choosenType !== null) {
    resultats = resultats.filter((result) => {
      if (result.type === choosenType) {
        return true
      }
      return false
    })
  }
  return (
    <ResultContainer className={results}>
      <div className={resultsTop}>
        <h3 role="status" aria-live="polite">
          {resultats.length} résultat(s) pour le terme &quot;{query}&quot;
        </h3>
      </div>
      <SearchFilters
        tabType={tabType}
        choosenType={choosenType}
        toggleType={toggleType}
      />
      <ResultsContainer className={resultsContainer}>
        {resultats.length === 0 && (
          <div>Pas de résultats, veuillez modifier votre requête</div>
        )}
        <SearchFadeIn delay={150}>
          <ul id="list-result" role="listbox" className={listResult}>
            {resultats.map((result, index) => {
              return <Result key={result.url} result={result} index={index} />
            })}
          </ul>
        </SearchFadeIn>
      </ResultsContainer>
    </ResultContainer>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Result = ({ result }) => {
  let iconType = ""
  let nodeType = ""
  switch (result.type) {
    case "node__carnet_d_adresse":
      iconType = "address-book"
      nodeType = "Carnet d'adresse"
      break
    case "node__actualites":
      iconType = "newspaper"
      nodeType = "Actualité"
      break
    case "node__evenements":
      iconType = "calendar"
      nodeType = "Evènement"
      break
    case "node__teleformulaires":
      iconType = "profile"
      nodeType = "Téléformulaire"
      break
    default:
      iconType = "file-empty"
      nodeType = "Page"
  }
  return (
    <li>
      <ResultItems className={resultItem}>
        <TransitionFade link={result.url}>
          <div className={resultContent}>
            <ResultType className={resultType}>
              <Icon className={resultTypeIcon} size={20} icon={iconType} />
              <h3 className={resultTypeType}>{nodeType}</h3>
            </ResultType>
            <h4 className={resultTitle}>{result.title}</h4>
            {result.processed && (
              <p
                className={resultResume}
                dangerouslySetInnerHTML={{
                  __html: SummaryTransformer(result, summaryLength),
                }}
              />
            )}
          </div>
        </TransitionFade>
      </ResultItems>
    </li>
  )
}
//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

SearchResults.propTypes = {
  resultats: PropTypes.array.isRequired,
  query: PropTypes.string.isRequired,
}
Result.propTypes = {
  result: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default SearchResults
